import { LocalStorageService } from './LocalStorageService';

export function hasValidCenterId(centerId: unknown): centerId is string | number {
  return (
    centerId != null &&
    centerId !== '' &&
    centerId !== 'null' &&
    centerId !== 'undefined'
  );
}

/** Adds center_id to a where clause when the logged-in user has a valid center. */
export function applyCenterScopeToWhere(
  where: Record<string, unknown>,
  localStorage: LocalStorageService
): Record<string, unknown> {
  const centerId = localStorage.getCenterId();
  if (!hasValidCenterId(centerId)) {
    return where;
  }
  return { ...where, center_id: centerId };
}

/** Adds center_id to a create/update payload when the logged-in user has a valid center. */
export function appendCenterScopeToPayload<T extends Record<string, unknown>>(
  payload: T,
  localStorage: LocalStorageService
): T & { center_id?: string | number } {
  const centerId = localStorage.getCenterId();
  if (!hasValidCenterId(centerId)) {
    return payload;
  }
  return { ...payload, center_id: centerId };
}

/** Top-level client_id + optional center_id for analytics and similar APIs. */
export function buildTenantScopeParams(
  localStorage: LocalStorageService
): Record<string, number> {
  const params: Record<string, number> = {
    client_id: Number(localStorage.getClientId()),
  };

  const centerId = localStorage.getCenterId();
  if (hasValidCenterId(centerId)) {
    params['center_id'] = Number(centerId);
  }

  return params;
}
